import toast from "react-hot-toast";

// auth.js
export async function checkTokenValidity(navigate) {
    const token = localStorage.getItem("authToken");
    const tokenExpiry = localStorage.getItem("expiry");

    if (!token || !tokenExpiry || Date.now() > parseInt(tokenExpiry, 10)) {
        toast.error("Your session has expired. Please log in again.");
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        localStorage.removeItem("expiry");
         localStorage.removeItem("selectedCurrency");
        navigate("/");
        return false;
    }
    return true;
}

// auth.js
export function restrictUserRoutes(navigate, allowedUserType = 1) {
  const storedUser = localStorage.getItem("user");
  if (!storedUser) {
    // No user logged in
    navigate("/login"); // Redirect to login
    return false;
  }

  const user = JSON.parse(storedUser);

  if (user.user_type !== allowedUserType) {
   
    navigate("/"); // Redirect to home or another page
    return false;
  }

  return true; // Access allowed
}


export function restrictHostRoutes(navigate, allowedUserType = 2) {
  const storedUser = localStorage.getItem("user");
  if (!storedUser) {
    // No user logged in
    navigate("/login"); // Redirect to login
    return false;
  }

  const user = JSON.parse(storedUser);

  if (user.user_type !== allowedUserType) {
   
    navigate("/"); // Redirect to home or another page
    return false;
  }

  return true; // Access allowed
}
